module.exports = __webpack_public_path__ + "c53bf2525706baff031fbc79a8f100a3.svg";